import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import Classifier from "@/pages/Classifier";
import Admin from "@/pages/Admin";

function App() {
  return (
    <TooltipProvider delayDuration={150}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Classifier />} />
          <Route path="/result" element={<Classifier />} />
          <Route path="/r/:id" element={<Classifier />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  );
}

export default App;
